export default __webpack_public_path__ + "static/media/img-0406-austria-full-face.4972b56f.png";